export const SERVICES_LIST = [
  'Achat',
  'Administratif',
  "Bureau d'étude",
  'Communication',
  'Comptabilité & Finance',
  'Direction Générale',
  'Environnement',
  'Fonction Publique',
  'Juridique',
  'Logistique',
  'Maintenance',
  'Marketing',
  'Production',
  'Qualité Sécurité Environnement',
  'Ressources humaines',
  'Santé',
  'Services Généraux',
  'Travaux',
  'Vente / Commercial',
]

export const SERVICE_AUTRE_VALUE = 'Autre'
